import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { UserActionLogType } from '../models/user';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSyringe,
  faPaw,
  faMapMarkerAlt,
  faSkullCrossbones,
  faDizzy,
  faQuestionCircle,
  IconDefinition,
  faClipboardCheck,
  faDownload
} from '@fortawesome/free-solid-svg-icons';

export const UserActionTypeDataMap: { [K in UserActionLogType]: { icon: IconDefinition; trans: string } } = {
  [UserActionLogType.Any]: { icon: faQuestionCircle, trans: 'f-any' },
  [UserActionLogType.Injections]: { icon: faSyringe, trans: 'm-global-injections' },
  [UserActionLogType.Animals]: { icon: faPaw, trans: 'f-animals' },
  [UserActionLogType.AnimalsByInjection]: { icon: faPaw, trans: 'f-animals-by-inj' },
  [UserActionLogType.AnimalsDied]: { icon: faSkullCrossbones, trans: 'f-search-view-died' },
  [UserActionLogType.AnimalsDiedByLocation]: { icon: faSkullCrossbones, trans: 'm-location-animals-died' },
  [UserActionLogType.Locations]: { icon: faMapMarkerAlt, trans: 'm-locations' },
  [UserActionLogType.AnimalsSickByLocation]: { icon: faDizzy, trans: 'm-location-animals-sick' },
  [UserActionLogType.DeviceFirmwareUpdate]: { icon: faDownload, trans: 'm-firmware-update' }
};

interface ActionTypeSelectProps {
  value: UserActionLogType;
  onChange: (value: number) => void;
  cssClass?: string;
  allowAny?: boolean;
  fullWidth?: boolean;
}

const ActionTypeSelect = ({ value, onChange, cssClass, allowAny, fullWidth }: ActionTypeSelectProps) => {
  const { t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as number;

    // callback
    onChange && onChange(value);
  };

  const renderMenuItem = (type: UserActionLogType) => {
    return (
      <MenuItem value={type}>
        {<FontAwesomeIcon size="1x" icon={UserActionTypeDataMap[type].icon || faClipboardCheck} />}
        &nbsp;
        {t(UserActionTypeDataMap[type]?.trans) || t('f-any')}
      </MenuItem>
    );
  };

  return (
    <FormControl className={cssClass} size="small" fullWidth={fullWidth}>
      <InputLabel id="actTypeLabel">{t('f-act-type')}</InputLabel>

      <Select labelId="actTypeLabel" id="actTypeSelect" value={value} onChange={handleChange}>
        {allowAny && (
          <MenuItem value={0} id="act-any">
            {t('f-any')}
          </MenuItem>
        )}

        {renderMenuItem(UserActionLogType.Injections)}
        {renderMenuItem(UserActionLogType.Animals)}
        {renderMenuItem(UserActionLogType.AnimalsDied)}
        {renderMenuItem(UserActionLogType.AnimalsByInjection)}
        {renderMenuItem(UserActionLogType.Locations)}
        {renderMenuItem(UserActionLogType.AnimalsDiedByLocation)}
        {renderMenuItem(UserActionLogType.AnimalsSickByLocation)}
      </Select>
    </FormControl>
  );
};

export default ActionTypeSelect;
